module.exports = __webpack_public_path__ + "img/39.401bfebe.jpg";